// extracted by mini-css-extract-plugin
module.exports = {"item":"DTat","content":"DTbd","name":"DTq9","text":"DTah"};